import { render, staticRenderFns } from "./ServiceRepairForm.vue?vue&type=template&id=1a145c8a&scoped=true"
import script from "./ServiceRepairForm.vue?vue&type=script&lang=js"
export * from "./ServiceRepairForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceRepairForm.vue?vue&type=style&index=0&id=1a145c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a145c8a",
  null
  
)

export default component.exports